/** Traductions historique fermetures journalières (FR / AR) */
export const dailyClosingHistoryModalFr = {
  title: 'Historique des Fermetures',
  startDate: 'Date de début',
  endDate: 'Date de fin',
  reset: 'Réinitialiser',
  clearFilters: 'Effacer filtres',
  resetClosing: 'Réinitialiser la clôture',
  resetClosingConfirm: 'Annuler cette clôture ? La journée pourra être clôturée à nouveau.',
  resetClosingSuccess: 'Clôture annulée',
  resetClosingFailed: 'Impossible d\'annuler la clôture',
  noClosings: 'Aucune fermeture enregistrée',
  revenue: 'Revenus',
  purchases: 'Achats (réception)',
  payments: 'Paiements',
  expenses: 'Dépenses',
  net: 'Net trésorerie',
  netAccrual: 'Net comptable',
  salesCount: 'Nombre de ventes',
  purchasesCount: 'Nombre d\'achats',
  paymentsCount: 'Nombre de paiements',
  paymentsDetailTitle: 'Détail des paiements',
  paymentsMethodLineOne: '1 paiement {{method}} · {{amount}}',
  paymentsMethodLineMany: '{{count}} paiements {{method}} · {{amount}}',
  paymentsNoDetail: 'Aucun paiement fournisseur ce jour',
  expensesCount: 'Nombre de dépenses',
  previousClosing: 'Clôture précédente',
  currentClosingStamp: 'Clôture (date & heure)',
  expensesRegister: 'Dépenses (caisse)',
  expensesAccrual: 'Dépenses (montant total)',
  closingTime: 'Heure de fermeture',
  warnings: 'Avertissements',
  balanceSheet: 'Bilan',
  assets: 'Actifs',
  liabilities: 'Passifs',
  equity: 'Capitaux propres',
  capital: 'Capital social',
  retainedEarnings: 'Résultats reportés',
  currentYearProfit: "Résultat de l'exercice",
  supplierDebts: 'Dettes fournisseurs (nous devons)',
  externalFinancing: 'Financement externe (hors caisse)',
  externalFinancingHint: 'Paiements tagués hors caisse — identique au dashboard et au rapport de caisse. Différent des passifs (dettes fournisseurs = nous devons).',
  noExternalFinancing: 'Aucun financement externe',
  balanceDifference: 'Écart bilan',
  balanced: 'Bilan équilibré',
  close: 'Fermer',
  priceAdjustments: 'Ajustements de prix manuels',
  manualPriceLines: 'Lignes à prix manuel'
};

export const dailyClosingHistoryModalAr = {
  title: 'تاريخ الإغلاق',
  startDate: 'من تاريخ',
  endDate: 'إلى تاريخ',
  reset: 'إعادة تعيين',
  clearFilters: 'مسح التصفية',
  resetClosing: 'إلغاء الإغلاق',
  resetClosingConfirm: 'إلغاء هذا الإغلاق؟ يمكنك إغلاق اليوم مرة أخرى بعد ذلك.',
  resetClosingSuccess: 'تم إلغاء الإغلاق',
  resetClosingFailed: 'تعذر إلغاء الإغلاق',
  noClosings: 'لا توجد إغلاقات محفوظة',
  revenue: 'الإيرادات',
  purchases: 'المشتريات (استلام)',
  payments: 'المدفوعات',
  expenses: 'المصروفات',
  net: 'صافي السيولة',
  netAccrual: 'صافي محاسبي',
  salesCount: 'عدد المبيعات',
  purchasesCount: 'عدد المشتريات',
  paymentsCount: 'عدد المدفوعات',
  paymentsDetailTitle: 'تفاصيل المدفوعات',
  paymentsMethodLineOne: 'دفعة واحدة {{method}} · {{amount}}',
  paymentsMethodLineMany: '{{count}} دفعات {{method}} · {{amount}}',
  paymentsNoDetail: 'لا توجد مدفوعات للموردين في هذا اليوم',
  expensesCount: 'عدد المصروفات',
  previousClosing: 'الإغلاق السابق',
  currentClosingStamp: 'الإغلاق (التاريخ والوقت)',
  expensesRegister: 'المصروفات (الصندوق)',
  expensesAccrual: 'المصروفات (المبلغ الكلي)',
  closingTime: 'وقت الإغلاق',
  warnings: 'تحذيرات',
  balanceSheet: 'ملخص المحل',
  assets: 'الأصول',
  liabilities: 'الخصوم',
  equity: 'حقوق الملكية',
  capital: 'رأس المال',
  retainedEarnings: 'الأرباح المحتجزة',
  currentYearProfit: 'نتيجة السنة',
  supplierDebts: 'ديون الموردين (نحن مدينون)',
  externalFinancing: 'تمويل خارجي (خارج الصندوق)',
  externalFinancingHint: 'مدفوعات مسجلة خارج الصندوق — نفس لوحة المدير وتقرير الصندوق. يختلف عن الخصوم (ديون الموردين = نحن مدينون).',
  noExternalFinancing: 'لا يوجد تمويل خارجي',
  balanceDifference: 'فرق الميزانية',
  balanced: 'الحساب متوازن',
  close: 'إغلاق',
  priceAdjustments: 'تعديلات الأسعار اليدوية',
  manualPriceLines: 'أسطر بسعر يدوي'
};
